import type { IActionObject } from '../user/user.actions';

export const SET_CUSTOMER_SWITCHES = 'SET_CUSTOMER_SWITCHES';

export interface IPerseoSwitches {
  myCredits: boolean;
  perseGlobal: { [key: string]: boolean };
}

export const setSwitches = (
  switches: IPerseoSwitches
): IActionObject<IPerseoSwitches> => ({
  type: SET_CUSTOMER_SWITCHES,
  payload: switches
});
